import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function OfflineStatus(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};
  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };
  return (
    <Accordion.Item
      eventKey="offline-status"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>Offline Status</Accordion.Title>
        <Accordion.SubTitle>
          Set the appearance and behavior when agents are not available.
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-6">
          <div className="text-sm font-medium mb-2">Offline Title</div>
          <TextInput
            value={workingLanguageConfig.offlineTitle || ""}
            setValue={(value) => updateLanguageConfig({ offlineTitle: value })}
            showEmojiButton={false}
            maxWordCount={30}
          />
          <div className="text-sm font-medium mb-2">Offline Message</div>
          <TextInput
            value={workingLanguageConfig.offlineMessage || ""}
            setValue={(value) =>
              updateLanguageConfig({ offlineMessage: value })
            }
            showEmojiButton={false}
            maxWordCount={125}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
